import moment from 'moment-timezone';

/**
 * Given a date, get the week number
 * (e.g)
 * input => getWeekNumber(new Date()) '2019-12-05'
 * output => 49
 */
export function getWeekNumber(date?: moment.MomentInput): number {
  if (date) {
    return moment(date).week();
  }

  return moment().week();
}

/**
 * Given a date, get the iso week number
 * (e.g)
 * input => getIsoWeekNumber(new Date()) '2021-12-31'
 * output => 52
 */
export function getIsoWeekNumber(date?: moment.MomentInput): number {
  if (date) {
    return moment(date).isoWeek();
  }

  return moment().isoWeek();
}

/**
 * Given a date, get the day of the week
 * (e.g)
 * input => getWeekDay(new Date()) '2019-12-05'
 * output => 4
 */
export function getWeekDay(date?: moment.MomentInput): number {
  if (date) {
    return moment(date).day();
  }

  return moment().day();
}

export function getWeekYear(date?: moment.MomentInput): number {
  if (date) {
    return moment(date).weekYear();
  }

  return moment().weekYear();
}

/**
 * Current time in ms, truncated to whole seconds.
 *
 * The backend stores `started_at` / `completed_at` / etc. in MySQL `timestamp`
 * columns (second precision). The mobile app sends timestamps rounded to
 * seconds so the value the client sends and the value the DB stores stay
 * equal across requests — otherwise the backend interprets the sub-second
 * drift as a "workout restart" and skips side effects like caloric
 * expenditure tracking. Use this anywhere a timestamp is captured to be sent
 * to the API.
 */
export function nowMs(): number {
  return Math.floor(Date.now() / 1000) * 1000;
}
